import React from 'react';
import './secondaryshort.css'

const Secondaryctashort = (props) => {
    return ( 
        <button className='short-sec-cta-bg2'>
            <nav className='yellow-cont-bg2'  onClick={props.onClick}>
                <h2 className='cta-text-primary2'>{props.title}</h2>
            </nav>
        </button>
     );
}
 
export default Secondaryctashort;